import RouteUtils from '~/core/utils/RouteUtils';
import {policyPaths} from '~/paths';
import {OKTA_ROLE} from '~/config';

const routes = [
	{
		path: policyPaths.policyRenewPagePattern,
		title: 'Renew Policy',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyRenewalPage');
		}),
	},
	{
		path: policyPaths.policySRPPagePattern,
		title: 'Renew Policy',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyRenewalPage');
		}),
	},
	{
		path: policyPaths.policyRenewBusinessDetailsPagePattern,
		title: 'Renew Policy Business Details',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/RenewBusinessDetailsPage');
		}),
	},
	{
		path: policyPaths.policyRenewWagesPagePattern,
		title: 'Renew Policy',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/RenewWagesPage');
		}),
	},
	{
		path: policyPaths.policyRenewPremiumPagePattern,
		title: 'Renew Policy Premium',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/RenewPremiumPage');
		}),
	},
	{
		path: policyPaths.policyRenewConfirmationPagePattern,
		title: 'Renew Policy Confirmation',
		isDynamicRouteRequired: true,
		requiresAuth: true,
		requiredRoles: [OKTA_ROLE.EMPLOYER, OKTA_ROLE.BROKER],
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/RenewConfirmationPage');
		}),
	},
];

export default routes;
